import React from "react";

function Lifesize() {
    return(
        <h1>
        This is the life size page</h1>
    );
}

export default Lifesize